export const USER_ICON = {
  path: '', // M 125,5 155,90 245,90 175,145 200,230 125,180 50,230 75,145 5,90 95,90 z
  fillColor: 'yellow',
  fillOpacity: 0.8,
  scale: 0.1,
  strokeColor: 'black',
  strokeWeight: 1
}

export const MUSEUM_ICON = {
  path:
    // eslint-disable-next-line max-len
    'M63.201,35.316L45.522,18.199l-4.461-4.438C40.552,13.252,39.955,13,39.263,13s-1.286,0.252-1.776,0.758 l-4.488,4.438l-17.317,17.12h5.562v28.398h14.154V49.562h9.096v14.153h13.146V35.316H63.201z',
  fillColor: '#941b81',
  fillOpacity: 0.8,
  scale: 0.5,
  strokeColor: '#941b81',
  strokeWeight: 1
}



// WEBPACK FOOTER //
// ./src/frontend/map/icons.js